export { default } from "./patientAcknowledgment";
